"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DirectLeverbaarMaterieel() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224808" id="limited-drop-alerts" className="bg-blue-500 text-white relative py-24 md:py-32 bg-none">
      {}
      <div className="absolute inset-0 bg-blue-600/10 backdrop-brightness-110" />

      <div className="container mx-auto px-4 relative z-10 flex justify-center">
        <div ref={ref} className={`bg-white/10 backdrop-blur-xl border border-white/30 p-8 md:p-12 rounded-3xl max-w-3xl text-center shadow-4xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-5xl font-bold text-white mb-6 tracking-tight">
            NEW DROP FRIDAY @ 6PM EST
          </h2>
          
          <p className="font-default text-lg md:text-xl text-white/90 mb-10 leading-relaxed">
            Our cutest collectibles are coming to the lab. Don&apos;t miss out on the tiny toys that bring big serotonin. Sign up for alerts to be the first in line!
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="w-full sm:w-auto text-base font-semibold shadow-xl bg-primary text-primary-foreground hover:bg-primary/90 rounded-full px-8">
              <Link to="#">
                Notify Me
              </Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="w-full sm:w-auto text-base font-semibold shadow-xl border-white text-white hover:bg-white/10 rounded-full px-8">
              <Link to="#">
                Explore the Shop
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}